module.exports = __webpack_public_path__ + "assets/normal/images/ComEmpty_5.14bbc193.png";